(() => {
  const DEFAULT_MOQ = 10;
  const PRODUCT_ROOT = 'product-info';

  const asInt = (value, fallback = DEFAULT_MOQ) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  function productMoq() {
    const marker = document.querySelector('[data-kenzio-product-moq]');
    return asInt(marker?.dataset.kenzioProductMoq, DEFAULT_MOQ);
  }

  function isLikelyProductQuantity(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'number') return false;
    if (!input.closest(PRODUCT_ROOT)) return false;
    const name = (input.name || '').toLowerCase();
    const id = (input.id || '').toLowerCase();
    const context = (input.parentElement?.parentElement?.textContent || '').toLowerCase();
    return name.includes('quantity') || id.includes('quantity') || context.includes('quantity');
  }

  function notifyQuantityChange(input) {
    if (input.dataset.kenzioSyncing === '1') return;
    input.dataset.kenzioSyncing = '1';
    try {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } finally {
      setTimeout(() => { delete input.dataset.kenzioSyncing; }, 0);
    }
  }

  function clampProductInput(input, sync = false) {
    if (!isLikelyProductQuantity(input)) return false;
    const moq = productMoq();
    input.min = String(moq);
    input.dataset.min = String(moq);
    const current = parseInt(input.value, 10) || 0;
    if (current >= moq) return false;
    input.value = String(moq);
    input.setAttribute('value', String(moq));
    if (sync) notifyQuantityChange(input);
    return true;
  }

  function clampAllProductInputs(sync = false) {
    document.querySelectorAll(`${PRODUCT_ROOT} input[type="number"]`).forEach((input) => clampProductInput(input, sync));
  }

  function cartInputs() {
    return Array.from(document.querySelectorAll('form#cart input[name="updates[]"][type="number"]'));
  }

  function clampCartInput(input, sync = false) {
    const moq = asInt(input.dataset.kenzioMoq || input.dataset.min, DEFAULT_MOQ);
    input.dataset.kenzioMoq = String(moq);
    input.dataset.min = String(moq);
    input.min = String(moq);
    const current = parseInt(input.value, 10) || 0;
    if (current === 0 || current >= moq) return false;
    input.value = String(moq);
    input.setAttribute('value', String(moq));
    if (sync) setTimeout(() => input.dispatchEvent(new Event('change', { bubbles: true })), 0);
    return true;
  }

  function clampAllCartInputs(sync = false) {
    cartInputs().forEach((input) => clampCartInput(input, sync));
  }

  function addMoqNote() {
    const moq = productMoq();
    const root = document.querySelector(PRODUCT_ROOT);
    if (!root || root.querySelector('.kz-moq-inline')) return;
    const quantityInputs = Array.from(root.querySelectorAll('input[type="number"]')).filter(isLikelyProductQuantity);
    const target = quantityInputs.find((input) => input.offsetParent !== null) || quantityInputs[0];
    if (!target) return;
    const wrap = target.closest('div');
    if (!wrap?.parentElement) return;
    const note = document.createElement('div');
    note.className = 'kz-moq-inline';
    note.textContent = `MINIMUM ORDER: ${moq} PCS`;
    wrap.parentElement.insertBefore(note, wrap.nextSibling);
  }

  function swapQikifyTierDisplay() {
    const custom = document.querySelector('[data-kenzio-volume-pricing]');
    if (!custom || !custom.hidden) return;
    const candidates = Array.from(document.querySelectorAll(`${PRODUCT_ROOT} div, ${PRODUCT_ROOT} section, ${PRODUCT_ROOT} aside`));
    const matching = candidates.filter((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase();
      return text.includes('TIER PRICING') && text.includes('1-49') && text.includes('50-99') && text.includes('100-249') && text.includes('250+') && !text.includes('QUANTITY');
    });
    if (!matching.length) return;
    matching.sort((a, b) => (a.textContent || '').length - (b.textContent || '').length);
    const qikifyTier = matching[0];
    if (custom.contains(qikifyTier) || qikifyTier.contains(custom)) return;
    qikifyTier.classList.add('kz-qikify-tier-hidden');
    custom.hidden = false;
  }

  function showCartMoqError() {
    const box = document.querySelector('#cart-errors');
    if (!box) return;
    box.innerHTML = '<div style="margin-top:12px;padding:10px 12px;border-left:4px solid #d80010;background:#f5f5f5;font-weight:800;color:#050505">Minimum order is 10 pcs per product. Please increase the quantity or remove the item.</div>';
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function cartHasViolation() {
    return cartInputs().some((input) => {
      const qty = parseInt(input.value, 10) || 0;
      const moq = asInt(input.dataset.kenzioMoq || input.dataset.min, DEFAULT_MOQ);
      return qty > 0 && qty < moq;
    });
  }

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('button[name="minus"]');
    if (minus) {
      const scope = minus.closest(PRODUCT_ROOT) || minus.closest('form#cart');
      const input = scope?.querySelector('input[type="number"]');
      if (input) {
        const moq = minus.closest(PRODUCT_ROOT) ? productMoq() : asInt(input.dataset.kenzioMoq || input.dataset.min, DEFAULT_MOQ);
        const qty = parseInt(input.value, 10) || 0;
        if (qty <= moq) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.value = String(moq);
          input.setAttribute('value', String(moq));
          return;
        }
      }
    }

    if (event.target.closest('button[type="submit"], input[type="submit"], [name="add"]')) {
      clampAllProductInputs(true);
    }

    if (event.target.closest('#checkout, [name="checkout"]')) {
      clampAllCartInputs(false);
      if (cartHasViolation()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showCartMoqError();
      }
    }
  }, true);

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'number') return;
    if (isLikelyProductQuantity(input)) {
      const moq = productMoq();
      input.min = String(moq);
      input.dataset.min = String(moq);
      updateTotalAmount();
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'number') return;
    if (input.dataset.kenzioSyncing === '1') return;
    if (isLikelyProductQuantity(input) && (parseInt(input.value, 10) || 0) < productMoq()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      clampProductInput(input, true);
      return;
    }
    if (input.matches('form#cart input[name="updates[]"]')) {
      const moq = asInt(input.dataset.kenzioMoq || input.dataset.min, DEFAULT_MOQ);
      const qty = parseInt(input.value, 10) || 0;
      if (qty > 0 && qty < moq) {
        event.preventDefault();
        event.stopImmediatePropagation();
        clampCartInput(input, true);
      }
    }
  }, true);

  function parseBulkPrice(text) {
    const m = String(text || '').match(/Rs\.\s*([\d,]+(?:\.\d+)?)/i);
    return m ? parseFloat(m[1].replace(/,/g, '')) : null;
  }

  function getBulkPriceForQty(qty) {
    const cards = Array.from(document.querySelectorAll('[data-kenzio-volume-pricing] .kz-volume-pricing__tier'));
    for (const card of cards) {
      const label = (card.querySelector('span')?.textContent || '').replace(/\s+/g, ' ').trim();
      const price = parseBulkPrice(card.querySelector('strong')?.textContent || '');
      if (!price) continue;
      const range = label.match(/(\d+)\s*[–-]\s*(\d+)/);
      const open = label.match(/(\d+)\s*\+/);
      if (range && qty >= +range[1] && qty <= +range[2]) return price;
      if (open && qty >= +open[1]) return price;
    }
    return null;
  }

  function updateTotalAmount() {
    const root = document.querySelector(PRODUCT_ROOT);
    if (!root) return;
    const input = Array.from(root.querySelectorAll('input[type="number"]')).find(isLikelyProductQuantity);
    if (!input) return;
    const qty = parseInt(input.value, 10) || 0;
    if (!qty) return;
    const unitPrice = getBulkPriceForQty(qty);
    if (unitPrice == null) return;

    let box = root.querySelector('.kz-total-amount');
    if (!box) {
      box = document.createElement('div');
      box.className = 'kz-total-amount';
      box.innerHTML = '<span>TOTAL AMOUNT</span><strong></strong>';
      const moq = root.querySelector('.kz-moq-inline');
      if (moq?.parentElement) moq.parentElement.insertBefore(box, moq.nextSibling);
      else {
        const quantity = input.closest('quantity-input') || input.closest('div');
        if (quantity?.parentElement) quantity.parentElement.insertBefore(box, quantity.nextSibling);
      }
    }
    const total = Math.round(qty * unitPrice * 100) / 100;
    box.querySelector('strong').textContent = 'Rs. ' + total.toLocaleString('en-IN', {minimumFractionDigits:Number.isInteger(total)?0:2, maximumFractionDigits:2});
  }

  function addTotalAmountStyles() {
    if (document.getElementById('kz-total-amount-styles')) return;
    const style = document.createElement('style');
    style.id = 'kz-total-amount-styles';
    style.textContent = '.kz-total-amount{display:flex;justify-content:space-between;align-items:center;margin-top:12px;padding:14px 16px;border:1px solid #dedede;border-radius:8px;background:#f7f7f7;font-weight:800}.kz-total-amount strong{font-size:20px}';
    document.head.appendChild(style);
  }

  document.addEventListener('submit', (event) => {
    if (event.target.closest(PRODUCT_ROOT)) clampAllProductInputs(true);
    if (event.target.id === 'cart') {
      clampAllCartInputs(false);
      if (cartHasViolation()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showCartMoqError();
      }
    }
  }, true);

  let queued = false;
  const refresh = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      clampAllProductInputs(true);
      clampAllCartInputs(true);
      addMoqNote();
      swapQikifyTierDisplay();
      addTotalAmountStyles();
      updateTotalAmount();
    });
  };

  const observer = new MutationObserver(refresh);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  setTimeout(refresh, 300);
  setTimeout(refresh, 800);
  setTimeout(refresh, 1500);
})();